import React from "react";
import { Button } from "antd";

import giphy from "../../assets/image/gipfy_logo.png";

import "./style.css";

const SOURCE_LABELS = {
  giphy: 'Giphy',
  klipy: 'KLIPY',
  redgifs: 'RedGIFs',
};

export const SearchModalFooter = ({
  count,
  onCancel,
  onOk,
  loading = false,
  source = 'giphy',
  totalLoaded = 0,
}) => {
  const disable = count === 0 || count > 10 || loading;

  return (
    <div className={"search_modal__footer"}>
      <div className="search_modal__footer__left">
        {source === 'giphy' ? (
          <img src={giphy} alt="giphy_logo" />
        ) : (
          <span className="search_modal__footer__source-label">
            {SOURCE_LABELS[source] || source}
          </span>
        )}
        {totalLoaded > 0 && (
          <span className="search_modal__footer__count">
            {totalLoaded} results loaded
          </span>
        )}
      </div>

      <div className={"search_modal__footer__buttons"}>
        <Button onClick={onCancel} disabled={loading}>Cancel</Button>
        <Button type="primary" disabled={disable} loading={loading} onClick={onOk}>
          {loading ? `Adding ${count} GIF(s)...` : `Add ${count} to playlist`}
        </Button>
      </div>
    </div>
  );
};
